import axios from 'axios';

axios.defaults.xsrfCookieName = '__Host-X';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
